/**
 * Utility functions for tip calculations
 */

/**
 * Checks if a custom tip amount is defined (not null and not undefined)
 */
export const hasCustomTip = (customTipAmount: number | null | undefined): boolean => {
  return customTipAmount !== null && customTipAmount !== undefined;
};

/**
 * Calculates tip amount for a single person (no split)
 */
export const calculateSinglePersonTip = (
  customTipAmount: number | null | undefined,
  baseAmount: number,
  tipPercentage: number
): number => {
  if (hasCustomTip(customTipAmount)) {
    return customTipAmount!;
  }
  return (baseAmount * tipPercentage) / 100;
};

/**
 * Calculates tip amount per person when splitting between multiple people
 */
export const calculateSplitTipPerPerson = (
  customTipAmount: number | null | undefined,
  totalPeople: number
): number => {
  if (!hasCustomTip(customTipAmount) || totalPeople <= 0) {
    return 0;
  }
  return Number((customTipAmount! / totalPeople).toFixed(2));
};

/**
 * Calculates tip amount for a specific person when splitting between multiple people
 */
export const calculateSplitTipForPerson = (
  customTipAmount: number | null | undefined,
  totalPeople: number,
  payingFor: number
): number => {
  if (!hasCustomTip(customTipAmount) || totalPeople <= 0 || payingFor <= 0) {
    return 0;
  }
  return Number(((customTipAmount! / totalPeople) * payingFor).toFixed(2));
};

/**
 * Calculates the final tip amount considering splits and custom amounts
 */
export const calculateFinalTipAmount = (
  customTipAmount: number | null | undefined,
  baseAmount: number,
  tipPercentage: number
): number => {
  if (hasCustomTip(customTipAmount)) {
    return customTipAmount!;
  }
  return Number(((baseAmount * tipPercentage) / 100).toFixed(2));
};
